import React, { useEffect, useRef, useState } from 'react';
import useStateWithCallback from "use-state-with-callback";
import { IAGrid } from '../../../Components/IInterfaces';
import { CommonUtil } from '../../../utils/CommonUtil';
import { NetworkManager } from '../../../Components/NetworkManager';
import { Constants } from '../../Languages/Constants';
import EditBrokerDetails from '../../InterchangeApplication/EditBrokerDetails';
import BrokerStatusRenderer from '../../InterchangeApplication/BrokerStatusRenderer';
import InspectionGrid from '../../InspectionGrid/InspectionGrid';
import GenericPopup from '../../../Components/GenericPopup';
import BrokerCarrierForm from './BrokerCarrierForm';

const BrokerCarrierGrid = ({count}: any) => {
  const saasOrgId = CommonUtil.getSaasOrgId();
  const [popupInfo, setPopupInfo] = useState<any>(null);
  const userGridRef = useRef<IAGrid>(null);

  const [users, setUsers] = useStateWithCallback([], () => {
    if (userGridRef.current) {
      userGridRef.current.columnFittoSize();
    }
  });

  const openEditPopup = (rowData: any) => {
    setPopupInfo({
      mode: "edit",
      formKey: "BrokerCarrier",
      initialData: rowData,
    });
  };

  const closePopup = () => {
    setPopupInfo(null)
  };

  const getAllDetails = () => {
    const orgUrl = `api/v2/carrier-broker/all/?saasOrgId=${saasOrgId}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, onGetAllDetails, onLoginError);
  };

  useEffect(() => {
    getAllDetails();
  }, [count?.carrierCount]);

  useEffect(() => {
    if(popupInfo === null){
    getAllDetails();
  }
  }, [popupInfo]);

  const [userColumns] = useState([
    {
      field: 'isCarrier',
      headerName: "Broker/Carrier",
      resizable: true,
      flex: 1,
      sortable: true,
      cellStyle: baseStyle,
      headerClass: 'header-white',
      filter: 'agTextColumnFilter',
      cellRenderer: (params: any) => (params.value === true ? <span>Carrier</span> : <span>Broker</span>)
    },
    {
      field: 'name',
      headerName: CommonUtil.getMessageText(Constants.NAME, `Name`),
      resizable: true,
      flex: 1,
      sortable: true,
      cellStyle: baseStyle,
      headerClass: 'header-white',
      filter: 'agTextColumnFilter',
      cellRenderer: (params: any) => (
            <span
                onClick={() => openEditPopup(params.data)}
                style={{ color: '#0d6efd', cursor: 'pointer', textDecoration: 'underline' }}
            >
            {params.value}
            </span>
        )
    },
    {
      field: 'phoneNumber',
      headerName: CommonUtil.getMessageText(Constants.PHONE_NUMBER, 'Phone Number'),
      resizable: true,
      flex: 1,
      sortable: true,
      cellStyle: baseStyle,
      headerClass: 'header-white',
      filter: 'agTextColumnFilter'
    },
    {
      field: 'email',
      headerName: 'Email',
      resizable: true,
      flex: 1,
      sortable: true,
      cellStyle: baseStyle,
      headerClass: 'header-white',
      filter: 'agTextColumnFilter'
    },
    {
      field: 'dotNumber',
      headerName: CommonUtil.getMessageText(Constants.USDOT_NUMBER, 'USDOT Number'),
      resizable: true,
      flex: 1,
      sortable: true,
      cellStyle: baseStyle,
      headerClass: 'header-white',
      filter: 'agTextColumnFilter'
    },
    {
      field: 'creationDate',
      headerName: 'Creation Date',
      resizable: true,
      flex: 1,
      sortable: true,
      cellStyle: baseStyle,
      headerClass: 'header-white',
      filter: 'agTextColumnFilter'
    },
    {
      field: 'createdBy',
      headerName: CommonUtil.getMessageText(Constants.CREATED_BY, 'Created By'),
      resizable: true,
      flex: 1,
      sortable: true,
      cellStyle: baseStyle,
      headerClass: 'header-white',
      filter: 'agTextColumnFilter'
    },
    {
      field: "status",
      headerName: CommonUtil.getMessageText(Constants.STATUS, `Status`),
      resizable: true,
      flex: 1,
      sortable: true,
      cellStyle: baseStyle,
      headerClass: 'header-white',
      filter: 'agTextColumnFilter',
      cellRenderer: BrokerStatusRenderer
    }
  ]);

  const onReceiveData = (userData: any) => {
    localStorage.setItem("claimId", userData.claimId);
    console.log(userData);
  };

  const onGetAllDetails = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      const sorted: any = [...(Array.isArray(restData) ? restData : [restData])]
        .sort((a, b) => (b.documentId || 0) - (a.documentId || 0));
      setUsers(sorted);
    }
  };

  const onLoginError = (err: any) => {
    console.error("Login Error:", err);
  };

  return (
    <div className="container-fluid container-fluid-padding mt-3" style={{ backgroundColor: 'white' }}>
      <div className="row fs-7 pt-1">
        <div className="ag-theme-alpine ag-theme-customeTheme gridHeight" style={{ height: "calc(100vh - 330px)", width: "100%", paddingLeft: "8px", paddingRight: "5px" }}>
          <InspectionGrid
            cols={userColumns}
            rows={users}
            pageSize={100}
            addNew={true}
            tooltip={`Add`}
            name={`Add`}
            headerHeight={CommonUtil.GRID_HEADER_HEIGHT}
            rowHeight={CommonUtil.GRID_ROW_HEIGHT}
            ref={userGridRef}
            method={{ onReceiveData }}
          />
        </div>
      </div>
      {popupInfo && (
        <GenericPopup
          header="Broker/Carrier"
          mode={popupInfo.mode}
          onClose={closePopup}
          size="lg"
        >
          <BrokerCarrierForm mode={popupInfo.mode} onClose={closePopup} initialData={popupInfo.initialData}/>
        </GenericPopup>
      )}
    </div>
  );
};

const baseStyle = {
  fontWeight: '400',
  letterSpacing: '0px',
  fontSize: '13px',
  fontFamily: 'poppins',
  paddingTop: '5px'
};

export default BrokerCarrierGrid;
